"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaStyles = exports.MediaContextProvider = exports.Media = exports.AppMedia = void 0;
var _fresnel = require("@artsy/fresnel");
var AppMedia = exports.AppMedia = (0, _fresnel.createMedia)({
  breakpoints: {
    mobile: 0,
    computer: 768
  }
});
var mediaStyles = exports.mediaStyles = AppMedia.createMediaStyle();
var Media = exports.Media = AppMedia.Media,
  MediaContextProvider = exports.MediaContextProvider = AppMedia.MediaContextProvider;